module.exports = " <div> <div class=row> <div class=\"input-field col s12 offset-m1 m10 offset-l3 l6\"> <h3>{{title}}</h3> </div> </div> <div class=row> <div class=\"col s12 offset-m1 m10 offset-l3 l6\"> {{result}} </div> <div class=\"col s12 offset-m1 m10 offset-l3 l6\" v-if=redirecting> Önt hamarosan átirányítjuk. </div> <div class=\"col s12 offset-m1 m10 offset-l3 l6\" v-if=!success> <a v-link=\"{path: backLink}\">Újrapróbálkozás</a> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Activation.vue
// module id = 147
// module chunks = 0